import { useTranslation } from "react-i18next";

import {
  resolveProvinceTranslations,
  useProvinces,
} from "@av/apps/recruitment/ats-common/services/lookup-entities/provinces/provinces";

export type JobLocationParts = {
  streetAddressPart?: string;
  cityPart?: string;
  provincePart?: string;
  cityProvinceText?: string;
  fullText?: string;
};

type UseJobLocationPartsOptions = {
  provinceFormat?: "short" | "long";
  streetAddress?: string;
};

export function useJobLocationParts(
  city?: string,
  subdivisionCode?: string,
  options?: UseJobLocationPartsOptions
): JobLocationParts {
  const { t } = useTranslation();
  const { data: provinceOptions = [] } = useProvinces({ searchText: subdivisionCode });
  const { provinceFormat = "long", streetAddress } = options ?? {};

  const streetAddressPart = streetAddress?.trim() || undefined;
  const cityPart = city?.trim() || undefined;
  const province = subdivisionCode ? provinceOptions[0] : undefined;
  const provincePart =
    subdivisionCode && provinceFormat === "long"
      ? resolveProvinceTranslations(t, subdivisionCode, province?.name)
      : (province?.shortName ?? province?.name);
  const cityProvinceText = [cityPart, provincePart].filter(Boolean).join(", ") || undefined;
  const fullText = [streetAddressPart, cityProvinceText].filter(Boolean).join(", ") || undefined;

  return {
    streetAddressPart,
    cityPart,
    provincePart,
    cityProvinceText,
    fullText,
  };
}
